import Vue from 'vue';
import Component from 'vue-class-component';

@Component
export default class StepsMixin extends Vue {
    created() {
        window.scrollTo(0, 0);
    }

    public updateOnboardingState(uuidLead: string, actualStep: number, nextStep?: any) {
        if (!uuidLead) {
            const { uuidLead: uuid } = this.$store.getters['applicationStore/applicationData'];
            uuidLead = uuid;
        }

        const payload = {
            state_id: uuidLead,
            actual_step: actualStep,
            state_json: this.$store.getters['applicationStore/applicationData']
        };

        return this.$onboardingService
            .updateOnboardingState(payload)
            .then(() => {
                if (nextStep && `/${nextStep}` !== this.$route.path) {
                    this.$router.replace(`/${nextStep}`);
                } else if (`/paso${actualStep + 1}` !== this.$route.path) {
                    this.$router.replace(`/paso${actualStep + 1}`);
                }
            })
            .catch((error: Error) => {
                console.error('steps - updateOnboardingState', error);
                console.error(error);
                this.$bvToast.toast(
                    'No se ha podido actualizar la información proporcionada. Esto puede deberse a un problema de conexión. Por favor, asegúrese de que está conectado a internet e inténtelo de nuevo.',
                    {
                        title: 'Error al actualizar la información',
                        autoHideDelay: 5000,
                        variant: 'danger'
                    }
                );
            });
    }

    async getAccountInterveners(account: any) {
        try {
            const res = await this.$onboardingService.getIntervenersAccount(account.uuid);
            return res.data.accounts_intervener;
        } catch (error) {
            console.error('steps - getAccountInterveners', error);
            console.error(error);
        }
    }
}
